import { render, staticRenderFns } from "./contentRole.vue?vue&type=template&id=1251b8fb&scoped=true&"
import script from "./contentRole.vue?vue&type=script&lang=js&"
export * from "./contentRole.vue?vue&type=script&lang=js&"
import style0 from "./contentRole.vue?vue&type=style&index=0&id=1251b8fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251b8fb",
  null
  
)

export default component.exports